import { render, staticRenderFns } from "./GoldPartner.vue?vue&type=template&id=788a9033&"
import script from "./GoldPartner.vue?vue&type=script&lang=js&"
export * from "./GoldPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports